module.exports = __webpack_public_path__ + "img/PM_A02_front_horizontal_en.164a36b7.png";